import React from 'react';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from '../../../types';
import { isValidGlobalBehaviour } from '../../../utils/validation';

const required = value => (isValidGlobalBehaviour(value, 'accountNo') ? undefined : 'Required');

const OldAccountNumber = ({ maxAccountLength }) => (
  <Content>
    {({ accountNumberHeader, accountNumberError }) => (
      <Field name="account_number" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <FormField>
            <FieldHeader
              name="account_number"
              hasError={touched && !!error}
              title={accountNumberHeader}
              validationMessage={accountNumberError}
            />
            <FieldBody hasError={touched && !!error}>
              <Field name="account_number" type="input" validate={required}>
                {({ input }) => <Input type="tel" {...input} maxLength={maxAccountLength} />}
              </Field>
            </FieldBody>
          </FormField>
        )}
      </Field>
    )}
  </Content>
);

OldAccountNumber.propTypes = {
  maxAccountLength: PropTypes.number
};

OldAccountNumber.defaultProps = {
  maxAccountLength: 8
};

export default OldAccountNumber;
